// src/app/components/searshForms/mobile/mobileSearchSheet/MobileSearchSheet.js
import React, { startTransition, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SearchSheet } from "@zorni/components-lib";

import { useSearch } from "../../../../hooks/SearchContext";
import { useCityAutocomplete } from "../../../../hooks/useCityAutocomplete";
import { useRecentSearches } from "../../searchForm/hooks/useRecentSearches";
import { buildSearchUrl } from "../../searchUrl";

/**
 * Feuille de recherche mobile (SearchSheet de la components-lib), branchée
 * sur l'état de recherche partagé, la recherche de villes et les recherches
 * récentes. Ouverte par `setSheetOpen(true)` depuis le récapitulatif
 * (SearchSummary) de l'accueil, de la page résultats ou de l'en-tête.
 */
export default function MobileSearchSheet() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { search, updateSearch, sheetOpen, setSheetOpen } = useSearch();

  const [query, setQuery] = useState("");
  const { results: cities, loading } = useCityAutocomplete(query);
  const { recentSearches, addRecentSearch } = useRecentSearches({ max: 6 });

  const destinationOptions = useMemo(
    () =>
      cities.map((item) => {
        const label = item.country ? `${item.city}, ${item.country}` : item.city;
        return { label, value: label };
      }),
    [cities]
  );

  const recentOptions = useMemo(
    () =>
      recentSearches.map((item) => ({
        label: item.label || item.destination || "",
        value: item.value || item.destination || "",
        dateLabel: typeof item.dateRange === "string" ? item.dateRange : undefined,
        startDate: item.startDate,
        endDate: item.endDate,
        travelers: item.travelers,
      })),
    [recentSearches]
  );

  const handleSubmit = (values) => {
    updateSearch(values);

    if ((values.destination || "").trim()) {
      addRecentSearch({
        label: values.destination,
        value: values.destination,
        startDate: values.startDate || "",
        endDate: values.endDate || "",
        travelers: { adult: values.adults, child: values.children, baby: values.babies },
      });
    }

    setQuery("");
    setSheetOpen(false);
    startTransition(() => {
      navigate(buildSearchUrl(values));
    });
  };

  return (
    <SearchSheet
      open={sheetOpen}
      onOpenChange={(open) => {
        if (!open) setQuery("");
        setSheetOpen(open);
      }}
      value={search}
      onSubmit={handleSubmit}
      destinationOptions={destinationOptions}
      recentOptions={recentOptions}
      isDestinationLoading={loading}
      onDestinationInput={setQuery}
      t={t}
    />
  );
}
